import {
  ChakraBox,
  ChakraFlex,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';
import { useHistory } from 'react-router-dom';

import Header from '~/components/common/Header';
import { PAGE_LAYOUT, PAGE_TOP_PADDING } from '~/lib/constants';
import { Path } from '~/routes/constants';

const TOP_LEVEL_ID = 'manage-content';

const ManageContent = () => {
  const history = useHistory();
  return (
    <ChakraBox
      paddingRight={PAGE_LAYOUT.rightSpacing}
      paddingTop={PAGE_LAYOUT.topSpacing}
    >
      <Header title="Manage Content" />
      <ChakraBox marginTop={PAGE_TOP_PADDING}>
        <Text marginBottom="10px" variant="h5">
          Note Templates
        </Text>
        <ChakraFlex gap="5px">
          <FireflyButton
            id={`${TOP_LEVEL_ID}-add-note-template`}
            leftIcon={FAIconName.plusSolid}
            onClick={() => {
              history.push(Path.ADMIN_MANAGE_CONTENT_NOTE_TEMPLATE);
            }}
          >
            Note Template
          </FireflyButton>

          <FireflyButton
            id={`${TOP_LEVEL_ID}-add-note-template-revision`}
            leftIcon={FAIconName.plusSolid}
            onClick={() => {
              history.push(Path.ADMIN_MANAGE_CONTENT_NOTE_TEMPLATE_REVISION);
            }}
          >
            Note Template Revision
          </FireflyButton>
        </ChakraFlex>
      </ChakraBox>
    </ChakraBox>
  );
};

export default ManageContent;
